import i18n from 'src/typescript/servicos/i18n/i18n.servico';

const modulosTextos = {
  // estruturaDaEmpresa
  appkey: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.appkey'),
  cadastroDeEmpregadores: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.cadastroDeEmpregadores'),
  company: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.company'),
  compemployee: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.compemployee'),
  employer: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.employer'),
  role: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.role'),
  rolegroup: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.rolegroup'),
  user: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.user'),
  usergroup: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.usergroup'),
  importarfuncionarios: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.importarfuncionarios'),
  exportfiles: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.exportfiles'),
  cadastros: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.cadastros'),
  auditoriadeintegracoes: i18n.t('permissions.moduloESubmodulos.modulos.estruturaDaEmpresa.auditoriaDeIntegracoes'),

  // calendarioDeTrabalho
  journey: i18n.t('permissions.moduloESubmodulos.modulos.calendarioDeTrabalho.journey'),
  routine: i18n.t('permissions.moduloESubmodulos.modulos.calendarioDeTrabalho.routine'),
  holidaysCalendar: i18n.t('permissions.moduloESubmodulos.modulos.calendarioDeTrabalho.holidaysCalendar'),
  feriaseafastamento: i18n.t('permissions.moduloESubmodulos.modulos.calendarioDeTrabalho.feriaseafastamento'),

  // correcoesETratamentoDePonto
  faketimelog: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.faketimelog'),
  autocorrect: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.autocorrect'),
  edittimelogkind: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.edittimelogkind'),
  ignoretimelog: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.ignoretimelog'),
  groupscomment: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.groupscomment'),
  trabalhoremoto: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.trabalhoremoto'),
  abstractjustify: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.abstractjustify'),
  justify: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.justify'),
  suspension: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.suspension'),
  absence: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.absence'),
  reason: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.reason'),
  problems: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.problems'),
  fastregister: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.fastregister'),
  unilateralcloses: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.unilateralcloses'),
  unlocker: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.unlocker'),
  autocomplete: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.autocomplete'),
  timelog: i18n.t('permissions.moduloESubmodulos.modulos.correcoesETratamentoDePonto.timelog'),

  // gestaoDePontoParticipativa
  regradetravamento: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.regradetravamento'),
  unlockerask: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.unlockerask'),
  lockconfirmation: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.lockconfirmation'),
  locker: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.locker'),
  objectapprovalrules: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.objectapprovalrules'),
  objectapprovalsrequest: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.objectapprovalsrequest'),
  aprovacaoemlotesolicitacoes: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.aprovacaoemlotesolicitacoes'),
  aprovacaoarquivo: i18n.t('permissions.moduloESubmodulos.modulos.gestaoDePontoParticipativa.aprovacaoarquivo'),

  // controleDeCustos
  notification: i18n.t('permissions.moduloESubmodulos.modulos.controleDeCustos.notification'),
  notificationrules: i18n.t('permissions.moduloESubmodulos.modulos.controleDeCustos.notificationrules'),
  acompanhamentodiario: i18n.t('permissions.moduloESubmodulos.modulos.controleDeCustos.acompanhamentodiario'),
  oncall: i18n.t('permissions.moduloESubmodulos.modulos.controleDeCustos.oncall'),
  faroldodp: i18n.t('permissions.moduloESubmodulos.modulos.controleDeCustos.farolDoDp'),

  // registroDePontos
  deviceregister: i18n.t('permissions.moduloESubmodulos.modulos.registroDePontos.deviceregister'),
  showtimelogs: i18n.t('permissions.moduloESubmodulos.modulos.registroDePontos.showtimelogs'),
  manage: i18n.t('permissions.moduloESubmodulos.modulos.registroDePontos.manage'),

  // reducaoDeRiscos
  biometric: i18n.t('permissions.moduloESubmodulos.modulos.reducaoDeRiscos.biometric'),
  controledeacesso: i18n.t('permissions.moduloESubmodulos.modulos.reducaoDeRiscos.controledeacesso'),
  userblock: i18n.t('permissions.moduloESubmodulos.modulos.reducaoDeRiscos.userblock'),

  // calculos
  customrules: i18n.t('permissions.moduloESubmodulos.modulos.calculos.customrules'),
  dayjourney: i18n.t('permissions.moduloESubmodulos.modulos.calculos.dayjourney'),
  timemeasurements: i18n.t('permissions.moduloESubmodulos.modulos.calculos.timemeasurements'),
  sumtimemeasurements: i18n.t('permissions.moduloESubmodulos.modulos.calculos.sumtimemeasurements'),
  arbitrarytms: i18n.t('permissions.moduloESubmodulos.modulos.calculos.arbitrarytms'),
  workhourbankrules: i18n.t('permissions.moduloESubmodulos.modulos.calculos.workhourbankrules'),
  workhourbankcloser: i18n.t('permissions.moduloESubmodulos.modulos.calculos.workhourbankcloser'),
  workhourbankobjects: i18n.t('permissions.moduloESubmodulos.modulos.calculos.workhourbankobjects'),
  workhourbankwindow: i18n.t('permissions.moduloESubmodulos.modulos.calculos.workhourbankwindow'),
  transferenciadeapontamentos: i18n.t('permissions.moduloESubmodulos.modulos.calculos.transferenciadeapontamentos'),
  workhourbankauth: i18n.t('permissions.moduloESubmodulos.modulos.calculos.workhourbankauth'),

  // exportadores
  e13: i18n.t('permissions.moduloESubmodulos.modulos.exportadores.e13'),

  // controleDeEstacoes
  controledeestacoesestacoes: i18n.t('permissions.moduloESubmodulos.modulos.controleDeEstacoes.controledeestacoesestacoes'),
  controledeestacoesinstalacao: i18n.t('permissions.moduloESubmodulos.modulos.controleDeEstacoes.controledeestacoesinstalacao'),
  controledeestacoesconfiguracao: i18n.t('permissions.moduloESubmodulos.modulos.controleDeEstacoes.controledeestacoesconfiguracao')
};

const submodulosTextos = {
  // compemployee
  camposcustomizaveisdafolha: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.camposcustomizaveisdafolha'),
  camposcustomizaveisdoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.camposcustomizaveisdoempregado'),
  camposopcionaisdoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.camposopcionaisdoempregado'),
  configuracoesdepontoebeneficiosdoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.configuracoesdepontoebeneficiosdoempregado'),
  dadoscadastraisdoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.dadoscadastraisdoempregado'),
  dadosdetrabalhodoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.dadosdetrabalhodoempregado'),
  escaladoempregado: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.escaladoempregado'),
  alteracoesmultiplas: i18n.t('permissions.moduloESubmodulos.submodulos.compemployee.alteracoesmultiplas'),

  // journey
  segmentacaodevisualizacaojornada: i18n.t('permissions.moduloESubmodulos.submodulos.journey.segmentacaodevisualizacaojornada'),

  // routine
  segmentacaodevisualizacaoescala: i18n.t('permissions.moduloESubmodulos.submodulos.routine.segmentacaodevisualizacaoescala'),

};

export { modulosTextos, submodulosTextos };
